export const Types = {
  SAVE_HOME_SETTING: 'SAVE_HOME_SETTING',
  SAVE_LIST_PAGE_SETTING: 'SAVE_LIST_PAGE_SETTING',
  }
  